import { FC } from "react";
import { IconWrapper } from "../IconWrapper";
import { IconProps } from "../Icons.types";

const ArrowUpRight: FC<IconProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="ArrowUpRight"
      icon={
        <svg
          width="inherit"
          height="inherit"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_1868_1867)">
            <path
              d="M4.34952 13.3443L13.6505 4.65573"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeMiterlimit="round"
            />
            <path
              d="M6.34229 4.40686L13.6506 4.65568L13.4017 11.9639"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeMiterlimit="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1868_1867">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default ArrowUpRight;
